import * as React from 'react';

import PropTypes from 'prop-types';
import {Scroller} from 'scroller';

import TouchableArea from './touchable-area';

function checkIfTouchDevice() {
    const isTouchDevice = !$('html').hasClass('no-touchevents');
    const platform = navigator && navigator.platform;
    const userAgent = navigator && navigator.userAgent;

    if (userAgent && userAgent.includes('CrOS')) {
        return false;
    }

    if (isTouchDevice && platform !== 'Win32' && platform !== 'Win64' && platform !== 'Windows') {
        return true;
    }

    return false;
}

export default class TouchWrapper extends React.Component {
    static propTypes = {
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired,
        contentWidth: PropTypes.number.isRequired,
        children: PropTypes.element.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            left: 0,
            top: 0,
            contentHeight: 0,
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.contentWidth !== this.props.contentWidth) {
            this.scroller.setDimensions(
                this.props.width,
                this.props.height,
                nextProps.contentWidth,
                this.state.contentHeight
            );
        }
    }

    UNSAFE_componentWillMount() {
        this.scroller = new Scroller(this.handleScroll);
    }

    render() {
        if (!checkIfTouchDevice()) {
            return React.cloneElement(this.props.children, {
                height: this.props.height,
                width: this.props.width,
            });
        }

        const content = React.cloneElement(this.props.children, {
            onContentHeightChange: this.onContentHeightChange,
            scrollLeft: this.state.left,
            scrollTop: this.state.top,
            height: this.props.height,
            width: this.props.width,
            overflowX: 'hidden',
            overflowY: 'hidden',
        });

        return <TouchableArea scroller={this.scroller}>{content}</TouchableArea>;
    }

    onContentHeightChange = (contentHeight) => {
        this.scroller.setDimensions(
            this.props.width,
            this.props.height,
            this.props.contentWidth,
            contentHeight
        );

        this.setState({contentHeight: contentHeight});
    };

    handleScroll = (left, top) => {
        this.setState({
            left: left,
            top: top,
        });
    };
}
